





























import Highlight from "@/highlight";

import { namespace } from "vuex-class";
import { Component, Vue } from "vue-property-decorator";

import { Match } from "@/types";
import SettingsButton from "@/components/SettingsButton.vue";

const Details = namespace("details");

@Component({
  components: { SettingsButton }
})
export default class ConceptDetails extends Vue {
  @Details.State("subject") private subject!: string;

  @Details.State("match") private match!: Match;

  get header(): string {
    return this.match.concept.text.phrase;
  }

  get formatted(): string {
    return Highlight.highlight("json", JSON.stringify(this.match, null, 2))
      .value;
  }
}
